import { Axios } from "./request";

const API_URL = "usersapi/v1/demands/";

export const DEMANDS_INFORMATION_API = {
  GetDemandsInformation: () => {
    return Axios.get(`${API_URL}GetDemandsInformation`);
  },
  AddDemandsInformation: (body) => {
    return Axios.post(`${API_URL}AddDemandsInformation`, body);
  },
  EditDemandsInformation: (body) => {
    return Axios.put(`${API_URL}EditDemandsInformation`, body);
  },
  GetDemandsInformationDetails: (profileNumber) => {
    return Axios.get(`${API_URL}GetDemandsInformationDetails?profileNumber=${profileNumber}`);
  },
  GetDemandsInformationDetailsAfterApprovalInspector: (profileNumber) => {
    return Axios.get(
      `${API_URL}GetDemandsInformationDetailsAfterApprovalInspector?profileNumber=${profileNumber}`
    );
  },
};
